import TableMui from 'src/components/TableMui'
import { TableMuiLabel } from 'src/components/TableMui/styles'
import { BatchAndStockBatchDue } from '../../StockMovementsTypes'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

interface ReplacementTableProps{
    listBatch: BatchAndStockBatchDue[]
    barcode: string
    onClick?: (item: BatchAndStockBatchDue) => void
}

export const ReplacementTable: React.FC<ReplacementTableProps> = ({ barcode, listBatch, onClick }) => (
  <TableMui
    columns={[
      { id: 'batch.idLote', label: 'Id Lote' },
      { id: 'expirationDateFormated', label: 'Validade' },
      { id: 'stockBatchDue.quantidade', label: 'Quantidade' },
    ]}
    rows={listBatch.map((item) => ({ ...item, expirationDateFormated: dayjs.utc(item.stockBatchDue.dataValidade).format('DD/MM/YYYY') }))}
    onRowClick={onClick}
    tableLabel={(
      <TableMuiLabel>
        {barcode}
      </TableMuiLabel>
      )}
  />
)
